import Select from '@acri-tools/react-tools/components/Select/Select';
import { Component } from 'react';
import { BYTE_PREFIX } from '../../utils/data';
import { REQUEST_TYPES } from '../../utils/requests';
import InputList from '../InputList/InputList';
import InputPeriodList from '../InputPeriodList/InputPeriodList';

import './RequestForm.css';
import classNames from 'classnames';
import Message from '@acri-tools/react-tools/components/Message/Message';


interface Props {
    request: any
    onChange: (updates: any) => void
}
interface State {
    productLists: Array<any>
    productUploadType: string

    fileUploadErrorMessage: string
}

enum TAB_TYPES {
    manualSelection = 'All products',
    fileUpload = 'Upload File'
}

const TABS = [
    { tab: TAB_TYPES.manualSelection, type: 'manual' },
    { tab: TAB_TYPES.fileUpload, type: 'file' }
]


export default class RequestForm extends Component<Props, State>{
    constructor(props: Props) {
        super(props);

        this.state = {
            productLists: [],
            productUploadType: 'manual',
            fileUploadErrorMessage: ''
        }
    }

    // remove only products from uploaded file, keep manual selection
    removeProductList = (productL: any): void => {
        let target_products = this.props.request.target_products.filter((product: any) => !productL.includes(product));
        this.checkProductLists(target_products);
        this.props.onChange({ target_products });
    }


    checkProductLists = (targetProducts: any): void => {
        let productLists = this.state.productLists;

        let exists: boolean;
        productLists.map((list: any, index: number) => {
            exists = list.products.some((product: any) => targetProducts.includes(product));
            if (!exists) productLists.splice(index, 1);
        })

        this.setState({ productLists });
    }



    getTab = (text: string, productUploadType: string) => {
        return <div
            className={classNames({
                "tab": true,
                "selected": productUploadType === this.state.productUploadType
            })}
            onClick={() => {
                this.setState({ productUploadType });
                if (productUploadType === 'file') {
                    this.checkProductLists(this.props.request.target_products);
                    this.setState({ fileUploadErrorMessage: '' });
                }
            }}
        >
            {text}
        </div>
    }


    render() {
        return (
            <div className="request-form">
                <Select
                    options={REQUEST_TYPES.map((v) => { return { value: v, label: v } })}
                    value={this.props.request.type}
                    onChange={(type: string) => { this.props.onChange({ type }) }}
                />
                <br />
                <br />

                <div className="row-2">
                    <div className="new-request-details">
                        <div className="form-field">
                            <label><i className="fas fa-satellite" /> Name*</label>
                            <input
                                type="text" value={this.props.request.name}
                                placeholder="Name" onChange={(e) => { this.props.onChange({ name: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label><i className="fas fa-satellite" /> Mission*</label>
                            <input
                                type="text" value={this.props.request.mission}
                                placeholder="Mission" onChange={(e) => { this.props.onChange({ mission: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label><i className="fas fa-tools" /> Instrument*</label>
                            <input
                                type="text" value={this.props.request.instrument}
                                placeholder="Instrument" onChange={(e) => { this.props.onChange({ instrument: e.target.value }) }}
                            />
                        </div>
                    </div>
                    <div className="new-request-details">
                        <div className="form-field">
                            <label><i className="fas fa-list" /> Dataset ID</label>
                            <input
                                type="text" value={this.props.request.dataset_id}
                                placeholder="Dataset ID" onChange={(e) => { this.props.onChange({ dataset_id: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label><i className="fas fa-satellite" /> Product Level</label>
                            <input
                                type="text" value={this.props.request.product_level}
                                placeholder="Product Level" onChange={(e) => { this.props.onChange({ product_level: e.target.value }) }}
                            />
                        </div>
                        <div className="volume-input">
                            <div className="form-field">
                                <label><i className="fas fa-server" /> Volume</label>
                                <input
                                    type="number" value={this.props.request.volume}
                                    placeholder="Volume" onChange={(e) => { this.props.onChange({ volume: e.target.value ? parseFloat(e.target.value) : undefined }) }}
                                />
                            </div>
                            <Select
                                options={BYTE_PREFIX.map((v) => { return { value: v, label: v } })}
                                value={this.props.request.volume_suffix}
                                onChange={(volume_suffix: string) => { this.props.onChange({ volume_suffix }) }}
                            />
                        </div>
                    </div>
                </div>
                <div className="row-2">
                    <InputList
                        type="text"
                        label={<>Product Type</>}
                        placeholder={"Product Type"}
                        values={this.props.request.product_type}
                        onChange={(product_type) => { this.props.onChange({ product_type }) }}
                    />
                    <InputList
                        type="text"
                        label={<><i className="fas fa-filter" /> Filters</>}
                        placeholder={"Filter"}
                        values={this.props.request.filters}
                        onChange={(filters) => { this.props.onChange({ filters }) }}
                    />
                </div>
                <InputList
                    type="text"
                    label={<><i className="fas fa-star-of-life" /> Additional requirements</>}
                    placeholder={"Additional requirement"}
                    values={this.props.request.additional_requirements}
                    onChange={(additional_requirements) => { this.props.onChange({ additional_requirements }) }}
                />

                <div className="form-field">
                    <label><i className="fas fa-list-ol" /> Number of products</label>
                    <input
                        type="number" value={this.props.request.nb_products}
                        placeholder="Number of products" onChange={(e) => { this.props.onChange({ nb_products: e.target.value ? parseFloat(e.target.value) : undefined }) }}
                    />
                </div>


                <div className="form-field">
                    <label><><i className="fas fa-star-of-life" /> Target products</></label>
                </div>

                <div className="tab-bar">
                    {
                        TABS.map(t => this.getTab(t.tab, t.type))
                    }
                </div>

                {
                    this.state.productUploadType === 'manual' ?
                        <InputList
                            type="text"
                            // label={<><i className="fas fa-star-of-life" /> Target products</>}
                            label=""
                            placeholder={"Target Products"}
                            values={this.props.request.target_products}
                            onChange={(target_products) => { this.props.onChange({ target_products }) }}
                        />
                        :
                        <>
                            <div className='input-list add-file-container'>

                                <div id='txt-file-input-container' className='txt-file-input-container'>

                                    <div className='select txt-input-selector'>
                                        <div id='txt-input-button' className='txt-input-button'>
                                            Select file
                                        </div>
                                    </div>

                                    <input
                                        id={'txt-file-input'}
                                        type="file"
                                        accept={"image/txt"}
                                        onChange={(e): void => {
                                            const file = e?.target?.files?.[0];
                                            if (!!file) {
                                                if (file.name.slice(file.name.indexOf('.') + 1) === 'txt') {
                                                    const fileReader = new FileReader();
                                                    fileReader.readAsText(file);
                                                    fileReader.onload = (): void => {
                                                        if (!!fileReader.result) {
                                                            let products = (fileReader.result as string).split("\n");
                                                            products = products.filter(product => (product !== ''));
                                                            let target_products = this.props.request.target_products.concat(products);
                                                            let productLists = this.state.productLists;
                                                            productLists.push({ products, fileName: file.name })

                                                            this.setState({ productLists, fileUploadErrorMessage: '' });
                                                            this.props.onChange({ target_products });
                                                        }

                                                    };
                                                } else {
                                                    this.setState({ fileUploadErrorMessage: 'Unsupported file format' });
                                                }
                                            }
                                        }} />
                                </div>
                                <div className='request-files-container'>
                                    {
                                        this.state.productLists?.map((productList: any, index: number) => {
                                            return productList.products?.length > 0 &&
                                                <div className='request-file-container'>
                                                    <div className='request-productlist-filename'>{productList.fileName}</div>
                                                    <div
                                                        key={index}
                                                        className='input-list-operation delete extra-right-margin'
                                                        onClick={() => this.removeProductList(productList.products)}
                                                    >
                                                        <i className="fas fa-times" />REMOVE FILE
                                                    </div>
                                                </div>
                                        })

                                    }
                                </div>
                            </div>



                            {
                                this.state.fileUploadErrorMessage &&
                                <Message message={this.state.fileUploadErrorMessage} type="warn" />
                            }
                        </>
                }

                <InputList
                    type="text"
                    label={<><i className="fas fa-draw-polygon" /> Area Of Interest</>}
                    placeholder={"Area Of Interest"}
                    values={this.props.request.aoi}
                    onChange={(aoi) => { this.props.onChange({ aoi }) }}
                />
                <InputPeriodList
                    label={<><i className="fas fa-calendar" /> Periods</>}
                    placeholder={"Periods"}
                    datetime
                    values={this.props.request.period}
                    onChange={(period) => { this.props.onChange({ period }) }}
                />

                <div className="form-field">
                    <label><i className="fas fa-list-ol" /> Repatriation channel</label>
                    <input
                        type="text" value={this.props.request.repatriation_channel}
                        placeholder="Repatriation channel" onChange={(e) => { this.props.onChange({ repatriation_channel: e.target.value }) }}
                    />
                </div>
                <div className="form-field">
                    <label><i className="fas fa-list-ol" /> User</label>
                    <input
                        type="text" value={this.props.request.user}
                        placeholder="User" onChange={(e) => { this.props.onChange({ user: e.target.value }) }}
                    />
                </div>
            </div>
        );
    }
};